export const caPostalCodeValidation =
  '^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][\\s]{1}\\d[ABCEGHJ-NPRSTV-Z]\\d$';
